

export const ConditionalWrapper = ({ condition, children, elseContent }) => {
  return condition ? <> { children } </> : <>{ elseContent }</>
}